import { env } from '@/config/env';

/**
 * Minimal structured logger. The only sanctioned logging surface — `console.*`
 * is banned by ESLint. Never log PII, tokens, or full error objects that may
 * contain them (instructions/06_SECURITY.md).
 *
 * In production, `debug`/`info` are suppressed; `warn`/`error` remain.
 */
type Fields = Record<string, unknown>;

function emit(level: 'debug' | 'info' | 'warn' | 'error', message: string, fields?: Fields): void {
  if (env.isProd && (level === 'debug' || level === 'info')) return;
  const payload = fields ? { message, ...fields } : { message };
  // eslint-disable-next-line no-console -- the logger is the one allowed sink
  console[level === 'debug' ? 'log' : level](`[badeel] ${level}:`, payload);
}

export const logger = {
  debug: (message: string, fields?: Fields) => emit('debug', message, fields),
  info: (message: string, fields?: Fields) => emit('info', message, fields),
  warn: (message: string, fields?: Fields) => emit('warn', message, fields),
  error: (message: string, fields?: Fields) => emit('error', message, fields),
};
